import { render, staticRenderFns } from "./Fieldset.vue?vue&type=template&id=37c9563a"
import script from "./Fieldset.vue?vue&type=script&lang=js"
export * from "./Fieldset.vue?vue&type=script&lang=js"
import style0 from "./Fieldset.vue?vue&type=style&index=0&id=37c9563a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports